import React, { useState } from "react";

const ProgressBar = ({ title, progress, bounty, bounty2, fvalue }) => {
  return (
    <div style={styles.container}>
      <div style={styles.label}>{title}</div>
      <div style={styles.progressBarContainer}>
        {/* <div style={styles.progressBackground}> */}
        <div
          style={{
            ...styles.progressBar,
            width: `${(bounty2 / bounty) * 100}%`,
            backgroundColor: "#ff6b6b",
          }}
        ></div>
        {/* </div> */}
        <div></div>
      </div>
      <div style={styles.bountyContainer}>
        <div style={{ width: "100%" }}>
          <span style={{ textAlign: "left", fontWeight: "bold" }}>
            BOP 200,000,000
          </span>
        </div>
        <div style={{ width: "100%", textAlign: "center" }}>
          <span style={{ fontWeight: "bold" }}>
            {/* {progress == "Ignore" ? 0 : progress}% */}

           
            {Math.round((bounty2 / bounty) * 100)} %
          </span>
        </div>
        <div style={{ width: "100%", textAlign: "right" }}>
          <span style={styles.bountyValue}>Remaining :{(bounty - bounty2).toLocaleString()} </span>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: "10px 20px",
    borderRadius: "8px",
    width: "auto",
    color: "#fff",
  },
  label: {
    marginBottom: "8px",
    fontSize: "14px",
    color: "#ddd",
  },
  progressBarContainer: {
    position: "relative",
    height: "16px",
    backgroundColor: "#333",
    borderRadius: "5px",
    overflow: "hidden",
    marginBottom: "10px",
  },
  // progressBackground: {
  //   boxShadow: "120px 80px 40px 20px #0ff",
  //   position:'relative',
  // },

  progressBar: {
    height: "100%",
    transition: "width 1s ease-in-out",
    boxShadow: "0 0 40px 20px #ff6b6b80",
  },

  progressText: {
    // // position: 'absolute',
    // top: '-22px',
    // right: '0',
    // fontSize: '14px',
    // color: '#ff6b6b',
  },
  bountyContainer: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "12px",
  },
  bountyValue: {
    fontSize: "12px",
    fontWeight: "bold",
    color: "#fff",
    textAlign: "end",
  },
};

export default ProgressBar;
